import { CustomAxios, getResponseData } from '../../axios';

export const getOnboardingStatusApi = (): Promise<any> =>
  CustomAxios.get(`portal/v1/onboarding/modules/status`).then(getResponseData);
